import { useFormContext, type FieldValues } from 'react-hook-form'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Input } from '../ui/input'

export interface TextFieldProps {
	name:         string
	label?:       string
	placeholder?: string
	disabled?:    boolean
	prefix?:      React.ReactNode
	suffix?:      React.ReactNode
	type?:        'text' | 'email' | 'tel' | 'url' | 'password'
	className?:   string
}

export function TextField({ name, label, placeholder, disabled, prefix, suffix, type = 'text', className }: TextFieldProps) {
	const form = useFormContext<FieldValues>()
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className={className}>
					{label && <FormLabel>{label}</FormLabel>}
					<FormControl>
						<Input
							{...field}
							type={type}
							value={(field.value as string | number | undefined) ?? ''}
							placeholder={placeholder}
							disabled={disabled}
							prefix={prefix}
							suffix={suffix}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
